import React from 'react'

const MoneyBackGuarantee = () => {

    const handleMouseEnter = () => {
    document.getElementById("moneyBackImage").classList.add("rotate-10");
  };
  const handleMouseLeave = () => {
    document.getElementById("moneyBackImage").classList.remove("rotate-10");
  };
  return (
     <div className="bg-[#EFF6FF]">
              <div className="mx-auto max-w-5xl">
                <div className="flex items-center flex-col md:flex-row justify-center md:p-16 p-6">
                  <div className="pr-6">
                    <img
                      id="moneyBackImage"
                      src="https://cdn.blackincae.com/UGj-image-3.png"
                      alt="Money Back Guarantee"
                      className="w-[313px] h-[278px] transition-transform duration-500"
                    />
                  </div>
                  <div className="md:w-1/2 w-full">
                    <a
                      href="https://scalequick.pay.clickbank.net/?cbitems=12&cbur=d"
                      className="text-gray-700 hover:underline hover:text-[#AB7C3B] cursor-pointer underline"
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                    >
                      No thanks Dr. Ali! I understand I can't get my Vitality
                      Box anywhere else at this huge discount. Even though this
                      is the fastest and easiest way to guarantee my best
                      possible results with Lung Renew. I like to do things the
                      hard way and figure them out on my own without this
                      powerful package.
                      <span className="bold-font">
                        I'll pass on a special Vitality Box.
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>


  )
}

export default MoneyBackGuarantee